export default __webpack_public_path__ + "static/media/hospital.03cf9ecf.png";